import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  ArrowDropDown as ArrowDropDownIcon,
  ArrowDropUpOutlined,
} from "@mui/icons-material";
const ColvisButton = ({
  handleToggleColumn,
  visibleColumns,
  colvisColumns,
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const menuItemStyles = {
    color: theme.palette.common.white,
    padding: "6px 16px",
    margin: "7px 10px",
    borderRadius: "8px",
    textAlign: "center",
    "& .MuiTouchRipple-root": {
      display: "none",
    },
  };

  return (
    <>
      <Button
        sx={{
          backgroundColor: theme.palette.warning.light,
          // borderRadius: '20px',
          // paddingTop: '4px',
          // paddingBottom: '4px',
          minWidth: "auto",
          "&:hover": {
            backgroundColor: theme.palette.warning.light,
          },
        }}
        variant="contained"
        onClick={handleClick}
        endIcon={
          Boolean(anchorEl) ? <ArrowDropUpOutlined /> : <ArrowDropDownIcon />
        }
      >
        Colvis
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          height: '300px',
          "& .MuiPaper-root": {
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        {colvisColumns.map((header, index) => {
          const isVisible = visibleColumns.find(
            (col) => col.field === header.field
          )?.visible;
          return (
            <MenuItem
              key={index}
              onClick={() => handleToggleColumn(header.field)}
              sx={{
                backgroundColor: isVisible
                  ? theme.palette.warning.light
                  : theme.palette.primary.main,
                "&:hover": {
                  backgroundColor: isVisible
                  ? theme.palette.warning.light
                  : theme.palette.primary.main,
                },
                ...menuItemStyles,
              }}
            >
              {header.headerName}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default ColvisButton;
